"use client";

import Link from "next/link";
import Image from "next/image";
import { useTheme } from "@/contexts/ThemeContext";
import { urlFor } from "@/sanity/lib/image";
import { SITE_SETTINGS_QUERYResult } from "@/sanity/types";

export function Footer({
  siteSettings,
}: {
  siteSettings: SITE_SETTINGS_QUERYResult | null;
}) {
  const { themeColors } = useTheme();

  const renderLogo = () => {
    if (siteSettings?.logo?.asset) {
      const imageUrl = urlFor(siteSettings.logo).height(180).url();
      return (
        <Image
          src={imageUrl}
          alt={siteSettings.logo.alt || siteSettings.siteName || "Logo"}
          height={60}
          width={180}
          className="object-contain"
        />
      );
    }
    return (
      <span className={`${themeColors.logoColor} tracking-tight`}>
        {siteSettings?.siteName || "ENDIVE CHAOS"}
      </span>
    );
  };

  // Fallback to default links if no socialLinks provided
  const socialLinks =
    siteSettings?.socialLinks && siteSettings.socialLinks.length > 0
      ? siteSettings.socialLinks
      : [];

  return (
    <div className="site-container site-grid pb-[40px] gap-y-[80px] md:gap-y-[300px] pt-[160px] md:pt-[200px] bg-transparent">
      <footer className="col-span-full flex flex-col md:flex-row items-start md:items-center md:justify-between gap-4 md:gap-0">
        <Link href="/">{renderLogo()}</Link>
        <div
          className={`flex flex-wrap items-center gap-4 ${themeColors.footerLinkColor}`}
        >
          {socialLinks.map(
            (link, index) =>
              link.url && (
                <a
                  key={index}
                  href={link.url}
                  target={link.url.startsWith("mailto:") ? "_self" : "_blank"}
                  rel={
                    link.url.startsWith("mailto:")
                      ? undefined
                      : "noopener noreferrer"
                  }
                  className={themeColors.footerLinkColor}
                >
                  {link.platform}
                </a>
              )
          )}
        </div>
      </footer>
    </div>
  );
}
